import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import type {
	InsightObjectAttribute,
	DefaultAttribute,
	ObjectAttribute,
	UserAttribute,
	GroupAttribute,
	StatusAttribute,
} from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';

export type AttributeValue = {
	value: string | null;
}[];

const getTransformedDefault = ({ defaultTypeValues }: DefaultAttribute): AttributeValue =>
	defaultTypeValues.map((val) => ({ value: val.value ?? null }));

const getTransformedObject = ({ objectTypeValues }: ObjectAttribute): AttributeValue =>
	objectTypeValues.map(({ referencedObject }) => ({ value: referencedObject.objectKey ?? null }));

const getTransformedUser = ({ userTypeValues }: UserAttribute): AttributeValue =>
	userTypeValues.map(({ user }) => ({ value: user.key ?? null }));

const getTransformedGroup = ({ groupTypeValues }: GroupAttribute): AttributeValue =>
	groupTypeValues.map(({ group }) => ({ value: group.name ?? null }));

const getTransformedStatus = ({ statusTypeValues }: StatusAttribute): AttributeValue =>
	statusTypeValues.map(({ status }) => ({ value: status.id ?? null }));

export const getAttributeValuesPayload = (attribute?: InsightObjectAttribute): AttributeValue => {
	if (attribute) {
		if (attribute.type === 'default') {
			return getTransformedDefault(attribute);
		}

		if (attribute.type === 'object') {
			return getTransformedObject(attribute);
		}

		if (attribute.type === 'user') {
			return getTransformedUser(attribute);
		}

		if (attribute.type === 'group') {
			return getTransformedGroup(attribute);
		}

		if (attribute.type === 'status') {
			return getTransformedStatus(attribute);
		}
	}

	fireCmdbErrorAnalytics({
		meta: {
			id: 'invalid.attribute.type',
			packageName: 'jiraServicedeskInsightObjectDetailsStore',
		},
	});

	return [{ value: null }];
};
